import { createApi } from "@reduxjs/toolkit/dist/query/react";
// import { defautBaseQuery } from "../../utils/API/fetchBaseQuery";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const sourceAPI = createApi({
    reducerPath: "sourceAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllSource: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Source/GetAllSource`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //** List API */
        getSource: builder.mutation({
            query: (userQuery) => ({
                url: '/Source/GetSourceList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        add: builder.mutation({
            query: (Details) => ({
                url: '/Source/AddSource',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** GetById API */
        getById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Source/GetSourceById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['Source'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        update: builder.mutation({
            query: (Details) => ({
                url: '/Source/UpdateSource',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['Source'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        delete: builder.mutation({
            query: (id) => ({
                url: `/Source/DeleteSource/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
    useGetSourceMutation, useAddMutation,
    useLazyGetByIdQuery, useUpdateMutation,
    useDeleteMutation ,  useLazyGetAllSourceQuery
} = sourceAPI

export default sourceAPI;